var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"wrap\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"header\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"col title\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, jade_debug[0].filename ));
buf.push("Title");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 5, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"col time\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, jade_debug[0].filename ));
buf.push("Time");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"col text original\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 6, jade_debug[0].filename ));
buf.push("Subtitle");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 7, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"col text edited\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 7, jade_debug[0].filename ));
buf.push("Edited Subtitle");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<span id=\"lastSync\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 8, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"manager\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\manager.jade" ));
buf.push("<div class=\"subtitles\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".wrap\r\n\t.header\r\n\t\t.row\r\n\t\t\t.col.title Title\r\n\t\t\t.col.time Time\r\n\t\t\t.col.text.original Subtitle\r\n\t\t\t.col.text.edited Edited Subtitle\r\n\t\t\t\tspan#lastSync \r\n\t.manager\r\n\t\t.subtitles");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/manager.jade
// module id = 418
// module chunks = 0